export const ALLOWED_INTERCOM_COUNTRIES = [
  'US',
  'CA',
  'PR',
  'GU',
  'VI',
  'AS',
  'MP',
  'UM',
];
